import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "20",
      height: "20",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h20v20H0z",
        style: {"fill":"color(display-p3 .851 .851 .851)","fill-opacity":"1"}
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M11.744 14.699V5.3h3.207v9.4zm-6.691 0V5.3H8.26v9.4z",
        style: {"fill":"currentColor","fill-opacity":"1"}
      })
    ], -1)
  ])))
}
export default { render: render }